import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'

// Local imports
import LeavePendingList from './LeavePendingList'

// API services
import { useGetAllFilteredLeaveApproval } from 'services/api/modules/leave/leaveApproval'
import { TablePagination } from '@mui/material'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const LeavePendingTab = () => {
  const [limit, setLimit] = useState(5)
  const [page, setPage] = useState(1)
  const { data, isLoading, error } = useGetAllFilteredLeaveApproval({
    status: 'pending',
    limit,
    page: page,
    sortBy: 'start_date',
    sortOrder: 'asc',
  })

  const handleChangePage = (e, newPage) => {
    setPage(newPage + 1)
  }

  const handleChangeLimit = (e) => {
    setLimit(parseInt(e.target.value, 10))
    setPage(1)
  }

  useEffect(() => {
    if (data === null) {
      setPage(1)
    }
  }, [data])

  const hasPendingLeaves = (data?.data || []).length > 0

  const loadingList = (
    <Box
      height={138}
      width={1}
      bgcolor="white.main"
      borderRadius={1}
      padding={{ xs: 2, lg: 3 }}
      mb={2}
      boxSizing="border-box"
      sx={{ boxShadow: 'none' }}
    >
      <Box height={1} display="flex" justifyContent="space-between" alignItems="center">
        <Box
          height={1}
          width={{ xs: 1, lg: 4 / 5 }}
          display="flex"
          alignItems="center"
          columnGap={2}
        >
          <Box display="flex" justifyContent="center" alignItems="center" width={90} height={90}>
            <Skeleton variant="circular" width={60} height={60} />
          </Box>
          <Box height={1} display="flex" flexDirection="column" justifyContent="space-between">
            <Box>
              <Skeleton variant="text" width={200} />
              <Skeleton variant="text" width={200} />
            </Box>
            <Skeleton variant="text" width={200} />
          </Box>
        </Box>
        <Skeleton variant="text" width={100} sx={{ display: { xs: 'none', lg: 'block' } }} />
      </Box>
    </Box>
  )

  return (
    <Box>
      {isLoading ? (
        loadingList
      ) : hasPendingLeaves ? (
        <>
          <Box maxHeight={'calc(100dvh - 235px)'} overflow={'auto'} className="scrollbar">
            {data?.data?.map((list, index) => (
              <LeavePendingList
                key={index}
                id={list.id}
                type={list.leave_type === 'Leave Request' ? 1 : 2}
                title={list.leave_policy_name}
                subtitle={list.type}
                startDate={list.start_date}
                endDate={list.end_date}
                user={list.request_from}
                imgUrl={list.request_from_image}
                amount={list.duration}
                requestId={list.leave_request_id}
              />
            ))}
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            borderTop={'1px solid'}
            borderColor={'gray-line.main'}
          >
            <TablePagination
              component="div"
              labelRowsPerPage="Show"
              SelectProps={{ sx: { borderRadius: 1 } }}
              showFirstButton
              showLastButton
              rowsPerPageOptions={[5, 10, 20, 50]}
              count={data?.total}
              page={page - 1}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeLimit}
            />
          </Box>
        </>
      ) : (
        <AdxEmptyStateV2
          title={
            error?.status === 403
              ? 'You are not authorized to access this feature. Please contact your admin for access.'
              : 'Nothing to show here'
          }
        />
      )}
    </Box>
  )
}

export default LeavePendingTab
